import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';

const DEFAULT_DEBOUNCE_INTERVAL = 500;

export const useDebounceValue = <T, >(value: T, debounceInterval: number = DEFAULT_DEBOUNCE_INTERVAL) => {
  const [debounceValue, setDebounceValue] = useState<T>(value);
  const setDebounceSearchQuery = useMemo(
    () => debounce(setDebounceValue, debounceInterval),
    [setDebounceValue, debounceInterval],
  );

  useEffect(() => setDebounceSearchQuery(value), [value, setDebounceSearchQuery]);

  return debounceValue;
};
